module.exports = __webpack_public_path__ + "img/蒙版组 85.a63e9332.png";